<template>
  <div>
    <stat-card class="my-2" v-model="total_active_users" :loading="loading">
      {{ $t('total unique user') }}
    </stat-card>

    <div>
      <v-card>
        <v-card-text style="min-height: 350px; position: relative">
          <dashboard-graph-loading v-if="loading"></dashboard-graph-loading>
          <template v-if="reportuserbydateOptions && !loading">
            <apexchart
              ref="reportuserbydate"
              type="area"
              height="350"
              :options="reportuserbydateOptions"
              :series="reportuserbydateSeries"
            ></apexchart>
          </template>
        </v-card-text>
      </v-card>
    </div>
  </div>
</template>

<script>
import StatCard from './StatCard'
import DashboardGraphLoading from './DashboardGraphLoading'
import api from '@/api'
import { mapGetters } from 'vuex'
import dayjs from 'dayjs'
import VueApexCharts from 'vue-apexcharts'
import utc from 'dayjs/plugin/utc'
dayjs.extend(utc)

export default {
  props: ['type', 'app', 'date', 'fbpost', 'value'],
  data() {
    return {
      loading: true,
      total_active_users: 0,

      reportuserbydateSeries: null,
      reportuserbydateOptions: {
        chart: {
          height: 350,
          type: 'area'
        },
        stroke: {
          curve: 'smooth'
        },
        plotOptions: {
          bar: {
            horizontal: false,
            columnWidth: '55%'
          }
        },
        dataLabels: {
          enabled: false
        },
        xaxis: {
          type: 'datetime',
          tickPlacement: 'on'
        },
        yaxis: {
          title: {
            text: this.$t('active users')
          },
          tickAmount: 1
        },
        tooltip: {
          x: {
            format: 'dd/MM/yy HH:mm'
          }
        }
      }
    }
  },
  components: {
    StatCard,
    DashboardGraphLoading,
    apexchart: VueApexCharts
  },
  computed: {
    ...mapGetters({
      selectedBot: 'selectedBot',
      currentLang: 'currentLang'
    })
  },
  async mounted() {
    await this.loadData()
  },
  methods: {
    async loadData() {
      this.loading = true
      var response = await this.fetchData()
      await this.$nextTick()
      this.total_active_users = response.total_active_users
      let rawdata = response.data

      if (rawdata.length < 7) {
        let day = 7 - rawdata.length
        let last_data = {
          active_users: 0,
          current_users: 0,
          date: dayjs().format('YYYY-MM-DDT00:00:00.000Z'),
          new_users: 0
        }
        if (day != 7) {
          last_data = rawdata[0]
        }
        for (let index = 1; index <= day; index++) {
          let date = dayjs(last_data.date).subtract(index + 1, 'days')
          rawdata.unshift({
            active_users: 0,
            current_users: 0,
            date: date.utcOffset(0, false).format('YYYY-MM-DDT00:00:00.000') + 'Z',
            new_users: 0
          })
        }
      }
      var data = rawdata.map(el => {
        return [
          dayjs(el.date, 'YYYY-MM-DDT00:00')
            .utcOffset(0, false)
            .valueOf(),
          parseInt(el.active_users)
        ]
      })
      var data2 = rawdata.map(el => {
        return [
          dayjs(el.date, 'YYYY-MM-DDT00:00')
            .utcOffset(0, false)
            .valueOf(),
          parseInt(el.new_users)
        ]
      })
      var data3 = rawdata.map(el => {
        return [
          dayjs(el.date, 'YYYY-MM-DDT00:00')
            .utcOffset(0, false)
            .valueOf(),
          parseInt(el.current_users)
        ]
      })
      this.reportuserbydateSeries = [
        { name: this.$t('active users'), data: data },
        { name: this.$t('new users'), data: data2 },
        { name: this.$t('existing users'), data: data3 }
      ]

      var max = 0
      if (data && data.length > 0) {
        max = data.reduce((acc, val) => {
          acc = acc === undefined || val[1] > acc ? val[1] : acc
          return acc
        })
      }
      if (this.$refs.reportuserbydate) {
        this.$refs.reportuserbydate.updateOptions({
          yaxis: {
            max: max + 5
          }
        })
      }
      this.$emit('onLoaded', { loading: false, data: this.reportuserbydateSeries })
      this.loading = false
    },
    fetchData() {
      return new Promise((resolve, reject) => {
        var data = {
          body: {
            pageid: this.selectedBot.pageid,
            app: this.app,
            from_date: dayjs(this.date.start).format('YYYY-MM-DD'),
            to_date: dayjs(this.date.end).format('YYYY-MM-DD')
          }
        }
        if (this.type == 'inbox') {
          api.post_report_inbox_user_by_date(data, (error, response) => {
            if (error) {
              reject(error)
            }

            if (response.responsecode == 200) {
              this.$emit('input', response.data)
              resolve(response)
            } else {
              reject(response.responsecode + ': Something went wrong')
            }
          })
        } else {
          if (this.fbpost) {
            data.body.question_source = this.fbpost.id
          }
          api.post_report_comment_user_by_date(data, (error, response) => {
            if (error) {
              reject(error)
            }

            if (response.responsecode == 200) {
              this.$emit('input', response.data)
              resolve(response)
            } else {
              reject(response.responsecode + ': Something went wrong')
            }
          })
        }
      })
    }
  },
  watch: {
    async app(newVal, oldVal) {
      if (newVal != oldVal) {
        await this.loadData()
      }
    },
    async date(newVal, oldVal) {
      if (newVal != oldVal) {
        await this.loadData()
      }
    }
    // date: {
    //   handler: async (newVal, oldVal) => {
    //     if (newVal != oldVal) {
    //       await this.loadData()
    //     }
    //   },
    //   deep: true
    // }
  }
}
</script>

<style lang="scss" scoped></style>



// WEBPACK FOOTER //
// src/components/view/analytics/ReportUserByDate.vue